export default __webpack_public_path__ + "472ade2ebb00225e80c9d30806a42696.png";